import {ModulePages} from "../../core/module-pages";
import {CashFlowIndex} from "./pages";

export function CashFlowModule() {
  return (
    <ModulePages routes={[
      { path: '' , render: (props) => <CashFlowIndex {...props} />}
    ]}/>
  )
}